import React, { lazy, Suspense } from "react";

const LazyComponent = (importFunc) => {
  const LazyComp = lazy(importFunc);
  return (
    <Suspense fallback={''}>
      <LazyComp />
    </Suspense>
  );
};

export default LazyComponent;
